export default import.meta.ROLLUP_FILE_URL_SlCwKFEpiqWwLzUj_Ju8hw;